import ObjectsIcon from './component'

export default ObjectsIcon
